export default "__VITE_ASSET__C4U_GmmL__"